<section class="h-full flex flex-col gap-2 z-0 relative p-2 lg:pl-0">

  <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
    <div>
      <div *ngIf="payments && payments.length">
        <h1 class="text-xs text-nowrap text-left">
          Showing {{(numberOfRecords * currentPage) - (payments.length != numberOfRecords ? (numberOfRecords - payments.length) : 0) }} of {{totalResults}} entries
        </h1>
      </div>
    </div>
    <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
      <div class="flex gap-2 flex-wrap">
        <div class="relative">
          <input [(ngModel)]="search" (input)="onSearchInput()" type="text" required placeholder="Search.." class="pl-8" />
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
        </div>
        <div class="min-w-48">
          <input type="text" [(ngModel)]="dateRange" [owlDateTime]="payDate" [owlDateTimeTrigger]="payDate"
            [selectMode]="'range'" (ngModelChange)="onDateChange($event)" placeholder="Payment Date" />
          <owl-date-time [pickerType]="'calendar'" #payDate></owl-date-time>
        </div>
        <div>
          <ng-select class="w-full sm:w-44" [(ngModel)]="selectedCustomerId"
            (ngModelChange)="onCustomerFilterChange()" [notFoundText]="'No record found'"
            placeholder="Select Customer" [clearable]="false" [searchable]="true">
            <ng-option [value]="null">Select Customer</ng-option>
            <ng-option *ngFor="let customer of customers" [value]="customer.id">{{ customer.DisplayName | titlecase }}</ng-option>
          </ng-select>
        </div>
        <div>
          <ng-select class="w-full sm:w-44" [(ngModel)]="selectedDepositStatus" (ngModelChange)="onDepositStatusFilterChange()"
              [notFoundText]="'No record found'" placeholder="All Deposit Status" [clearable]="false"
              [searchable]="false">
            <ng-option value="">All Deposit Status</ng-option>
            <ng-option value="deposited">Deposited</ng-option>
            <ng-option value="not_deposited">Not Deposited</ng-option>
                    </ng-select>
        </div>
      </div>
    </div>
  </div>

  <div class="flex-shrink-0">
    <h2><label class="font-bold" for="">Amount</label></h2>
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div *ngFor="let card of amountStatCards"
        class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
        <dl class="flex items-center">
          <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-8 w-8 text-base-dark">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
          </dt>
          <dd class="w-full ml-4 truncate text-right">
            <div class="text-xs-light flex-1 truncate">{{ card.label }}</div>
            <div class="text-xl font-bold text-base-dark flex-1 truncate">${{ (stats[card.key] || 0) | number:'1.2-2' }}</div>
          </dd>
        </dl>
      </div>
    </div>
  </div>

  <div class="flex-shrink-0">
    <h2><label class="font-bold" for="">Payments</label></h2>
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div *ngFor="let card of statusStatCards"
        class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
        <dl class="flex items-center">
          <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-8 w-8 text-base-dark">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
            </svg>
          </dt>
          <dd class="w-full ml-4 truncate text-right">
            <div class="text-xs-light flex-1 truncate">{{ card.label }}</div>
            <div class="text-xl font-bold text-base-dark flex-1 truncate">{{ stats[card.key] || 0 }}</div>
          </dd>
        </dl>
      </div>
    </div>
  </div>

  <div class="flex-1 min-h-0 overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
      <div class="flow-root h-full overflow-y-auto">
        <div class="-my-2">
          <div class="inline-block min-w-full py-2 align-middle">
            <table class="min-w-full border-separate border-spacing-0">
              <thead>
                <tr>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">#</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Actions</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Date</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Customer</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Invoice</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Batch</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Deposit Status</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Amount</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">QB ID</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let payment of (payments | paginate: { itemsPerPage: numberOfRecords, currentPage: currentPage, totalItems: totalResults }); let i = index"
                  class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ i + 1 }}</td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <div class="inline-flex relative">
                      <a href="javascript:void(0)" (click)="showActionButtons(i)"
                        class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                        </svg>
                      </a>
                      <div (outsideClick)="closeActionMenu($event)" outside-click
                        *ngIf="selectedDropdownIndex === i && toggleActionButtons"
                        class="action-menu"
                        role="menu" aria-orientation="vertical"
                        aria-labelledby="menu-button" tabindex="-1">
                        <app-qb-action-dropdown
                          class="divide-y divide-zinc-950/10 dark:divide-white/10"
                          [source]="'payment'"
                          [payment]="payment"
                          (pullFrom)="onSync(payment, 'pull')"
                          (pushTo)="onSync(payment, 'push')"
                          (voidPayment)="onVoid(payment)"
                          (deletePayment)="onDelete(payment)"
                        ></app-qb-action-dropdown>
                      </div>
                    </div>
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ (payment.TxnDate || payment.createdAt) | date: 'MM/DD/YYYY' }}</td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ (payment.CustomerRef?.name | titlecase) || 'N/A' }}</td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ payment.invoice?.DocNumber || payment.invoice?.Id || 'N/A' }}</td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ payment.batch }}</td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <span *ngIf="payment.Id; else notSynced" [ngClass]="payment.isDeposited ? 'badge-success' : 'badge-secondary'">{{ payment.isDeposited ? 'Deposited' : 'Not Deposited' }}</span>
                    <ng-template #notSynced>N/A</ng-template>
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">${{ payment.TotalAmt || '0' }}</td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ payment.Id || 'N/A' }}</td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <span [ngClass]="payment.status == 'created' ? 'badge-primary' : 'badge-success'">{{ (payment.status | titlecase) || 'N/A' }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-end">
      <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
    </div>
  </div>
</section>
